import { TranslationInfo } from "@shared/types/translation-info";
import { BaseTableFilter, parseToBaseTableFilter, TableFilter } from "./table-filter.type";

export interface BaseTableFilterGroup {
  /** The unique name of the group */
  readonly selector: string;
}
export interface TableFilterGroup extends BaseTableFilterGroup {
  groupNameTranslationInfo: TranslationInfo;
  groupType: TableFilterGroupType;
  /** How the children of the group should be combined in the rsql query */
  combinationStrategy: CombinationStrategy;
  children: TableFilter[];
}
export interface TableFilterGroupDto extends BaseTableFilterGroup {
  children: BaseTableFilter[];
}
export function parseToTableFilterGroupDto (filterGroup: TableFilterGroup): TableFilterGroupDto {
  return { selector: filterGroup.selector, children: filterGroup.children.map(parseToBaseTableFilter) };
}
// eslint-disable-next-line @tseslint/typedef
export const TABLE_FILTER_GROUP_TYPES = {
  MULTI_SELECT: "multi-select",
  SINGLE_SELECT: "single-select",
  TIMESPAN: "timespan"
};
export type TableFilterGroupType = typeof TABLE_FILTER_GROUP_TYPES[keyof typeof TABLE_FILTER_GROUP_TYPES];
// eslint-disable-next-line @tseslint/typedef
export const COMBINATION_STRATEGIES = {
  AND: "and",
  OR: "or"
} as const;
export type CombinationStrategy = typeof COMBINATION_STRATEGIES[keyof typeof COMBINATION_STRATEGIES];

